import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getTranslated } from "../../utils/CommonUtils";
import { setPickupGroupDetail, setExistingGroupDetail, setExistingUsersOfGroup } from "../../store/reducers/UUMReducer";
import { setContentLoading } from "../../store/reducers/CommonReducer";
import UMCContentSplitLayout from "../common/UMCContentSplitLayout";
import { getGroupResponse, getExistingGroupResponse } from "../../store/actions/CommonActions";
import { createPickupGroup, updatePickupGroup } from "../../store/actions/UUMActions";
import { UUM_URL } from "../../utils/Config";
import UMCUsersList from "../common/UMCUsersList";
import UMCAttrComponentView from "../common/UMCAttrComponentView";
import { deepMergeObjects } from "../../utils/SchemaParseUtils";
import { setCurrentMergedData, setBaseMergeData } from "../../store/reducers/CommonReducer";
import confirmModal from "../common/confirmModal";
import { validateAllMandatoryAttrGroup } from "../../utils/ValidationUtils"
import { CC_PRODUCT_ID } from "../../utils/Constants";
import { getSessionItem } from "../../utils/storageUtils";
import { showOxeErrorsByCodesInDialog } from "../../store/actions/OxeActions";
import { sendGTMEvent } from "../../utils/GTMUtils";

const PickupGroupDetailView = (props) => {

    const [domain_1View, setDomain_1View] = useState("")
    const [domain_2View, setDomain_2View] = useState("")

    const [addedUsers, setAddedUsers] = useState([]);

    // redux store variables
    const pickupGroupDetail = useSelector(state => state.uum.pickupGroupDetail) //create 
    const existingGroupDetail = useSelector(state => state.uum.existingGroupDetail) //update
    const existingUsersOfGroup = useSelector(state => state.uum.existingUsersOfGroup) //store unassociated users during update
    const [isGroupDetailReady, setGroupDetailReady] = useState(false);
    const [buttonEnabled, setButtonEnabled] = useState(false)

    const dict = useSelector(state => state.common.dict)
    const [usersMode, setUsersMode] = useState(); // "default", "review", or "delete" //new
    const [isUserListReady, setUserListReady] = useState(false);


    const currentMergedData = useSelector((state) => state.common.currentMergedData)
    const baseMergeData = useSelector((state) => state.common.baseMergeData)
    const dispatch = useDispatch()

    //------useEffect----------------------------------
    useEffect(() => { //new
        dispatch(setContentLoading(true))

        return (() => {
            dispatch(setCurrentMergedData(null))
            dispatch(setPickupGroupDetail(null))
            dispatch(setExistingUsersOfGroup(null))
            dispatch(setExistingGroupDetail(null))
            setDomain_1View(null)
            setDomain_2View(null)
        })
    }, [])

    useEffect(() => { //new
        if (props.currentOperation === 'create') {
            if (pickupGroupDetail?.length > 0) {
                if (domain_2View !== null && domain_1View !== null) {
                    dispatch(setContentLoading(false))
                }
            }
        }
        else if (props.currentOperation === 'update') {
            if (existingGroupDetail?.length > 0 && Array.isArray(existingUsersOfGroup)) {
                if (domain_2View !== null && domain_1View !== null) {
                    dispatch(setContentLoading(false))
                }
            }
        }
    }, [pickupGroupDetail, existingGroupDetail, existingUsersOfGroup])

    useEffect(() => {

        if (props.currentOperation === 'create' && pickupGroupDetail?.length > 0) {
            const eGD = pickupGroupDetail[0]?.domain
            const pickupGroup = eGD.find(domain => domain.id === 'pickupgroup');

            if (pickupGroup?.subdomain?.length) {
                const createRight = pickupGroup.subdomain.find(subDomain => subDomain.id === 'createright');
                const list = createRight?.list[0]?.enum || [];

                if (Array.isArray(list) && props.currentOperation === 'create' && pickupGroupDetail.length > 0 && list.length === 0) {
                    confirmModal({
                        title: getTranslated(dict, "MSG_NO_USER_AVAILABLE"),
                        onOk: () => {
                            props.setListViewMode(true)
                            dispatch(setContentLoading(false))
                        },
                        onCancel: () => {
                            return;
                        }
                    })
                }
            }
        }
    }, [pickupGroupDetail])

    useEffect(() => {
        if (props.currentOperation === 'update')//&& (!props.groupToEdit === undefined || !props.groupToEdit === '' )) 
        {
            if (props.groupToEdit) {
                const request = {
                    url: `${UUM_URL}/data/pickupgroup/${btoa(unescape(encodeURIComponent(props.groupToEdit)))}`,
                    action: (data) => {
                        dispatch(setExistingGroupDetail(data));
                        setGroupDetailReady(true); // <- set ready after dispatch
                    }
                };
                dispatch(getGroupResponse(props.currentOperation, request, () => {
                    props.setListViewMode(true)
                }))

                if (getSessionItem(CC_PRODUCT_ID)) {
                    const request1 = { url: `${UUM_URL}/data/detail/list/pickupgroup/${getSessionItem(CC_PRODUCT_ID)}`, action: setExistingUsersOfGroup }
                    dispatch(getExistingGroupResponse(request1))
                }
            }
        }
    }, [props.groupToEdit, props.currentOperation, getSessionItem(CC_PRODUCT_ID)])

    //------------------pickupgroup--------------------
    useEffect(() => {
        if (props.currentOperation === 'create')// || (isGroupDetailReady && props.currentOperation === 'update')) 
        {
            if (getSessionItem(CC_PRODUCT_ID)) {
                const request = { url: `${UUM_URL}/data/detail/list/pickupgroup/${getSessionItem(CC_PRODUCT_ID)}`, action: setPickupGroupDetail }
                dispatch(getGroupResponse(props.currentOperation, request), () => {
                    props.setListViewMode(true)
                })
            }
        }
    }, [props.currentOperation, getSessionItem(CC_PRODUCT_ID), existingUsersOfGroup, props.groupToEdit])

    useEffect(() => {
        if (pickupGroupDetail?.length && props.currentOperation === "create") {
            const gdS = pickupGroupDetail[0]?.domain
            const pickupGroup = gdS.find(domain => domain.id === 'pickupgroup');

            if (pickupGroup?.subdomain?.length) {

                const createLeft = pickupGroup.subdomain.find(subDomain => subDomain.id === 'createleft');
                const createRight = pickupGroup.subdomain.find(subDomain => subDomain.id === 'createright');

                if (createLeft) {
                    const domain1Content = getDomain1Content(createLeft)
                    setDomain_1View(domain1Content);

                    if (createLeft?.attribute) {
                        //schema attr
                        const schemaAttributes = getSchemaAttributes(createLeft) //[{ subdomain: [{ attribute: createLeft.attribute }] }];
                        //data attributes
                        let dataAttributes;
                        dataAttributes = getDataAttributes(createLeft)
                        //merging
                        const merged = getDeepMergedObjects(schemaAttributes, dataAttributes)
                        const flattenedAttributes = merged?.[0]?.subdomain?.[0]?.attribute || [];

                        dispatch(setBaseMergeData(flattenedAttributes));
                        dispatch(setCurrentMergedData(flattenedAttributes));
                    }
                }
                if (createRight) {
                    const domain2Content = getDomain2Content(createRight)
                    setDomain_2View(domain2Content);
                }
            }
        }
        if (existingGroupDetail?.length && props.currentOperation === 'update') {
            const eGD = existingGroupDetail[0]?.domain
            const pickupGroup = eGD.find(domain => domain.id === 'pickupgroup');

            if (pickupGroup?.subdomain?.length) {

                const createLeft = pickupGroup.subdomain.find(subDomain => subDomain.id === 'createleft');
                const createRight = pickupGroup.subdomain.find(subDomain => subDomain.id === 'createright');

                if (createLeft) {
                    if (createLeft?.attribute) {
                        //schema attr
                        const schemaAttributes = getSchemaAttributes(createLeft) //[{ subdomain: [{ attribute: createLeft.attribute }] }];
                        //data attributes
                        let dataAttributes;
                        dataAttributes = getDataAttributes(createLeft)

                        //merging
                        const merged = getDeepMergedObjects(schemaAttributes, dataAttributes)
                        const flattenedAttributes = merged?.[0]?.subdomain?.[0]?.attribute || [];

                        dispatch(setBaseMergeData(flattenedAttributes));
                        dispatch(setCurrentMergedData(flattenedAttributes));

                        const domain1Content = getDomain1Content(createLeft)
                        setDomain_1View(domain1Content);
                    }
                }
                if (createRight) {
                    const domain2Content = getDomain2Content(createRight)
                    setDomain_2View(domain2Content);
                }
            }
        }
    }, [pickupGroupDetail, existingGroupDetail, existingUsersOfGroup])

    useEffect(() => {
        if (
            props.currentOperation === "update" &&
            isGroupDetailReady &&
            existingGroupDetail?.length
        ) {
            const eGD = existingGroupDetail[0]?.domain;
            const pickupGroup = eGD?.find((domain) => domain.id === "pickupgroup");
            const createRight = pickupGroup?.subdomain?.find(
                (subDomain) => subDomain.id === "createright"
            );

            const existingEnum = createRight?.list?.[0]?.enum || [];

            //Only set addedUsers if it's not yet initialized
            if (!addedUsers || addedUsers.length === 0) {
                setAddedUsers(existingEnum);
            }
        }
    }, [isGroupDetailReady, existingGroupDetail, props.currentOperation]);

    useEffect(()=>{
        const evaluate = async () => {
        const result = await checkCreateButtonEnabled();
        setButtonEnabled(result);
    };
        evaluate();
    },[currentMergedData,addedUsers,usersMode,props.currentOperation])

    //check change in users for button enablement
    const checkChangeInUsersList = () => {
        if (existingGroupDetail) {

            const eGD = existingGroupDetail[0]?.domain
            if (eGD) {
                const pickupGroup = eGD.find(domain => domain.id === 'pickupgroup');
                const createRight = pickupGroup.subdomain.find(subDomain => subDomain.id === 'createright');

                if (createRight) {
                    const existingEnum = createRight?.list?.[0]?.enum || [];

                    //if (addedUsers.length === 0) return false;
                    // Check if lengths differ
                    if (addedUsers.length !== existingEnum.length) {
                        return true;
                    }

                    // Convert both lists to maps for efficient comparison
                    const existingMap = new Map(existingEnum.map(user => [user.id, user.action]));
                    const addedMap = new Map(addedUsers.map(user => [user.id, user.action]));

                    for (let [id, action] of addedMap.entries()) {
                        if (!existingMap.has(id) || existingMap.get(id) !== action) {
                            return true; // user missing or action differs
                        }
                    }
                    return false; // No change
                }
            }
        }
    }
    //------functions----------------------------------
    const getSchemaAttributes = (createLeft) => {
        return [{ subdomain: [{ attribute: createLeft.attribute }] }]
    }

    const getDataAttributes = (createLeft) => {
        return [{
            subdomain: [{
                attribute: createLeft.attribute.map(attr => ({
                    id: attr.id,
                    value: attr.value ?? "",
                    oldValue: attr.value ?? ""
                }))
            }]
        }];
    }

    const getDeepMergedObjects = (schemaAttributes, dataAttributes) => {
        return deepMergeObjects(schemaAttributes, dataAttributes);
    }

    const getDomain1Content = (domain) => {
        const attributes = domain.attribute;
        const otherAttrButes = {
            actionMode: props.currentOperation === 'create' ? "CREATE" : "UPDATE"
        }
        return attributes.map(
            (attribute, index) => <UMCAttrComponentView attribute={{ ...attribute, ...otherAttrButes }} />);
    }

    const getDomain2Content = (domain) => {
        const list = domain?.list[0]?.enum || [];

        return ( //default mode
            <UMCUsersList
                listItems={list} // all users - create | existing users - update
                width="100%"
                className="user-group-dd listbox-cmnt"
                placeholder={getTranslated(dict, "PH_SEARCH_GROUPS")}
                showAddButton={true}
                onAdd={(selected) => setAddedUsers(selected)}
                handleListBoxSelect={setAddedUsers}
                setModeInParent={setUsersMode} // default review delete
                isCreateMode={props.currentOperation === "create" ? true : false} //true -create | false - update
                unGroupedUsers={existingUsersOfGroup}
                onListLoaded={() => setUserListReady(true)}
            />
        )
        //}
    };

    const checkCreateButtonEnabled = async () => {  //used during both BUTTON enablement and HandleOK
        
        if (props.currentOperation === 'create') {
            const regexStatus = await validateAllMandatoryAttrGroup(currentMergedData,baseMergeData);
            if (usersMode !== "review") return false;
            if (!Array.isArray(currentMergedData) || currentMergedData.length === 0) return false;
            const fieldsStatus = isFieldsFilled();
            const userLength = addedUsers.length > 0;
            const finalStatus = fieldsStatus && userLength && regexStatus && usersMode === "review";
            return finalStatus;
        } else {
            const changeInUsersStatus = checkChangeInUsersList();
            const regexStatus = await validateAllMandatoryAttrGroup(currentMergedData,baseMergeData);
            const status = (verifyChangeInFields() && isFieldsFilled()) || ( changeInUsersStatus && usersMode === "review");
            const finalStatus = status && regexStatus; 
            return finalStatus;
        }
    };
    //compare and currentMergeData and baseMergeData
    const verifyChangeInFields = () => {
        return (JSON.stringify(currentMergedData) !== JSON.stringify(baseMergeData))
    }

    const isFieldsFilled = () => {
        const allFilled = currentMergedData?.every(attr =>
            !attr.mandatory //dont check non mandatory fields 
            || (attr.value !== undefined && attr.value !== null && attr.value !== "") //mandatory fields to be filled
        );
        return allFilled;
    }

    const goBackHandler = () => {
        let finalStatus = false;
        if (props.currentOperation === 'create') {
            const status = isFieldsFilled();
            const usersPresent = addedUsers.length !== 0;
            finalStatus = status || usersPresent;
        } else {
            finalStatus = verifyChangeInFields() || checkChangeInUsersList()
        }
        if (finalStatus) {
            confirmModal({
                title: "MSG_LEAVE_PAGE",
                content: "MSG_LOSE_CONFIG",
                onOk: () => {
                    props.changeCreateMode(true)
                    setAddedUsers(null)
                    dispatch(setExistingUsersOfGroup(null))
                    dispatch(setExistingGroupDetail(null))
                    //dispatch(setPickupGroupDetail(null))
                    setGroupDetailReady(false)
                }
            })
        } else {
            props.changeCreateMode(true)
            setAddedUsers(null)
        }
    }

    const buildFinalPayload = () => {
        if (props.currentOperation === 'create') {
            if (!pickupGroupDetail?.[0]) return null;

            // Step 1: Clone the parent domain without `subdomain`
            const { domain, ...restOfResponse } = pickupGroupDetail[0];  // destructure to remove domain
            const clonedResponse = { ...restOfResponse }; // this will now have: uid,help,displayname,label

            const { subdomain: originalSubdomain, ...restOfDomain } = domain[0]; //destructure to remove subdomain from domain obj
            const clonedSubdomain = JSON.parse(JSON.stringify(originalSubdomain));
            const clonedDomain = { ...restOfDomain }; // has domain object without subdomain

            // Step 2: Deep clone subdomain array
            const leftSubdomain = clonedSubdomain.find(sd => sd.id === "createleft");
            if (leftSubdomain && Array.isArray(leftSubdomain.attribute)) {
                leftSubdomain.attribute.forEach(attr => {
                    const currentAttr = currentMergedData.find(i => i.id === attr.id);
                    const baseAttr = baseMergeData.find(i => i.id === attr.id);

                    if (currentAttr) {
                        attr.value = currentAttr.value;
                        attr.oldValue = baseAttr?.value ?? currentAttr.value;//old group name in case of update/or name same in old and new value
                    }
                });
            }

            // Update right-side user list
            const rightSubdomain = clonedSubdomain.find(sd => sd.id === "createright");
            if (rightSubdomain?.list) {
                const userList = rightSubdomain.list.find(list => list.id === "users");

                if (userList) {
                    userList.enum = addedUsers.map(user => {
                        return {
                            ...user,
                            action: "ADD"
                        };
                    });
                }
            }
            // Step 5: Assemble final domain object with updated subDomain
            clonedDomain.subdomain = clonedSubdomain;
            clonedResponse.domain = [clonedDomain];
            return clonedResponse;

        } else {
            if (!existingGroupDetail?.[0]) return null;

            // Step 1: Clone the parent domain without `subdomain`
            const { domain, ...restOfResponse } = existingGroupDetail[0];  // destructure to remove domain
            const clonedResponse = { ...restOfResponse }; // this will now have: uid,help,displayname,label

            const { subdomain: originalSubdomain, ...restOfDomain } = domain[0]; //destructure to remove subdomain from domain obj
            const clonedSubdomain = JSON.parse(JSON.stringify(originalSubdomain));
            const clonedDomain = { ...restOfDomain }; // has domain object without subdomain

            // Step 2: Deep clone subdomain array

            const leftSubdomain = clonedSubdomain.find(sd => sd.id === "createleft");

            if (leftSubdomain && Array.isArray(leftSubdomain.attribute)) {
                leftSubdomain.attribute.forEach(attr => {
                    const currentAttr = currentMergedData.find(i => i.id === attr.id);
                    const baseAttr = baseMergeData.find(i => i.id === attr.id);

                    if (currentAttr) {
                        attr.value = currentAttr.value;
                        attr.oldValue = baseAttr?.value ?? currentAttr.value;//old group name in case of update/or name same in old and new value
                    }
                });
            }

            // Update right-side user list
            const rightSubdomain = clonedSubdomain.find(sd => sd.id === "createright");
            if (rightSubdomain?.list) {
                const userList = rightSubdomain.list.find(list => list.id === "users");

                if (userList) {
                    const existingUsers = userList.enum || [];
                    //const finalUsers = addedUsers || [];
                    const finalUsers = Array.isArray(addedUsers) ? addedUsers : [];

                    // Create maps for fast lookup
                    const existingMap = new Map(existingUsers.map(user => [user.id, user]));
                    const finalMap = new Map(finalUsers.map(user => [user.id, user]));

                    const mergedUsers = [];

                    // First: check existing users
                    for (const user of existingUsers) {
                        if (finalMap.has(user.id)) {
                            mergedUsers.push({ ...user, action: "NO_ACTION" });
                        } else {
                            mergedUsers.push({ ...user, action: "DELETE" });
                        }
                    }

                    // Next: check for new users not in existing
                    for (const user of finalUsers) {
                        if (!existingMap.has(user.id)) {
                            mergedUsers.push({ ...user, action: "ADD" });
                        }
                    }
                    userList.enum = mergedUsers;
                }
            }
            // Step 5: Assemble final domain object with updated subDomain
            clonedDomain.subdomain = clonedSubdomain;
            clonedResponse.domain = [clonedDomain];
            return clonedResponse;
        }
    };

    const checkAddedUsersPresent = () => {
        return addedUsers.length > 0 ? true : false
    }

    const HandleOK = () => {
        if (props.currentOperation === 'create') {
            if (checkCreateButtonEnabled()) {   //validation stage 
                const payload = buildFinalPayload();
                if (payload) {
                    dispatch(setContentLoading(true))
                    dispatch(createPickupGroup(payload, (status, result) => {
                        validateResponse(status, result)
                    }))
                }
            }
        } else {
            if (checkCreateButtonEnabled()) {
                const users = checkAddedUsersPresent()
                if (!users) {
                    confirmModal({
                        title: getTranslated(dict, "WARN_NO_USER_DELETES_GROUP"),
                        onOk: () => {
                            const updatePayload = buildFinalPayload();
                            if (updatePayload) {
                                dispatch(setContentLoading(true))
                                dispatch(updatePickupGroup(props.groupToEdit, updatePayload, (status, result) => {
                                    validateResponse(status, result)
                                }))
                            }
                        },
                        onCancel: () => {
                            return;
                        }
                    })
                } else {
                    const updatePayload = buildFinalPayload();
                    if (updatePayload) {
                        dispatch(setContentLoading(true))
                        dispatch(updatePickupGroup(props.groupToEdit, updatePayload, (status, result) => {
                            validateResponse(status, result)
                        }))
                    }
                }
            }
        }

        // send GTM event for Pickup group creation/update
        sendGTMEvent({
            event: "umc_easy_user_groups",
            action: props.currentOperation === "create" ? "Pickup group creation triggered" : "Pickup group update triggered"
        })

        const validateResponse = (status, data) => {
            if (status) {
                dispatch(setBaseMergeData(null))
                dispatch(setCurrentMergedData(null))
                setAddedUsers([])
                dispatch(setExistingUsersOfGroup(null))
                dispatch(setExistingGroupDetail(null))
                setGroupDetailReady(false)
                //dispatch(setPickupGroupDetail(null))
                props.setListViewMode(true)
                dispatch(setContentLoading(false))
            } else {
                dispatch(setContentLoading(false))
                dispatch(showOxeErrorsByCodesInDialog(data))
            }
        }
    }

    //------DOM render--------------------------------
    return <UMCContentSplitLayout
        domain_1={domain_1View}
        domain_2={domain_2View}
        heading_1={props.heading_1}
        heading_2={props.heading_2}
        okBtnLabel={props.currentOperation === 'create' ? getTranslated(dict, "LABEL_CREATE") : getTranslated(dict, "LABEL_UPDATE")}
        goBackHandler={() => goBackHandler()}
        handleOK={HandleOK}
        disablOKBtn={!buttonEnabled}
    />

}

export default PickupGroupDetailView;